// extracted by mini-css-extract-plugin
export default {"UpdateCell":"bptasks_UpdateCell__pvdsn","CanDiasabledBtn":"bptasks_CanDiasabledBtn__Rf2iQ","AlignCenter":"bptasks_AlignCenter__pzNFE"};